import FreecshotPlusEventApi from '@/api/events/freecshot-plus';
import styles from '@/app/(events)/events/freecshot-plus/index/style.module.scss';
import clsx from 'clsx';
import {forwardRef, useState} from 'react';

const FreecshotPlusMessage = forwardRef(function FreecshotPlusMessage(
  {data, handleClose},
  ref,
) {
  const {userNickname} = data;
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    try {
      const response = await FreecshotPlusEventApi.getEventStatus({
        work: 'POST_EVENT_MESSAGE',
        message: message,
      });
      if (response.result > 0) {
        handleClose();
        location.reload();
      }
    } catch (error) {
      location.reload();
    }
  };

  const handleChangeMessage = (e) => {
    let inputValue = e.target.value;
    let blob = new Blob([inputValue]);
    if (blob.size > 1000) {
      // 1000바이트 이하가 될 때까지 뒤에서부터 잘라냄
      while (new Blob([inputValue]).size > 1000) {
        inputValue = inputValue.slice(0, -1);
      }
    }
    setMessage(inputValue);
  };

  return (
    <div className={clsx(styles.event_layer, styles.letter)}>
      <div className={styles.letter_area}>
        <strong className={styles.title}>
          프릭샷 플러스에게{' '}
          <em>
            칭찬 한 마디 해주세요<i className={styles.italic}>!</i>
          </em>
        </strong>
        <div className={styles.letter_input}>
          <span className={styles.nick}>TO. 프릭샷 플러스</span>
          <div className='input_box'>
            <textarea
              value={message}
              placeholder='내용을 입력해주세요'
              onChange={handleChangeMessage}></textarea>
          </div>
          <span className={clsx(styles.nick, styles.from)}>
            from. {userNickname}
          </span>
        </div>
        <button
          type='button'
          className={styles.btn_submit}
          disabled={!message}
          onClick={handleSubmit}>
          보내기
        </button>
        <div className={styles.info_box}>
          <p>
            프릭샷 플러스를 이용해주셔서 감사합니다.
            <br />
            여러분의 소중한 칭찬으로 한 뼘 더 성장합니다
          </p>
          <span>
            추첨 경품 당첨자에 한해 프릭샷 플러스 채널에서
            <br />
            게시글로 안내드립니다.
          </span>
        </div>
      </div>
      <button type='button' className={styles.btn_close} onClick={handleClose}>
        닫기
      </button>
    </div>
  );
});

export default FreecshotPlusMessage;
